// The last rung of stale-chunk recovery: a page that cannot load says so.
// Plain DOM on purpose — the app that would render it is the thing that failed.
import { unregisterAllServiceWorkers, clearAllCaches } from '@/composables/useServiceWorkerSafety'
import { boundedCleanup } from './staleChunkError'

export function showChunkFailureNotice(path: string): void {
  if (document.getElementById('ssi-chunk-failure')) return
  const box = document.createElement('div')
  box.id = 'ssi-chunk-failure'
  box.setAttribute('role', 'alert')
  box.style.cssText = 'position:fixed;inset:0;z-index:2000;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;padding:24px;text-align:center;background:#e8e3dd;color:#2c2622;font:16px/1.4 system-ui,sans-serif'
  const msg = document.createElement('p')
  msg.textContent = "This page didn't load. Your connection may have kept an old copy of the app."
  const btn = document.createElement('button')
  btn.type = 'button'
  btn.textContent = 'Reload the app'
  btn.style.cssText = 'padding:10px 20px;border-radius:999px;border:1px solid rgba(44,38,34,.2);background:#fff;font:600 15px system-ui,sans-serif;cursor:pointer'
  btn.addEventListener('click', async () => {
    try { await boundedCleanup(async () => { await unregisterAllServiceWorkers(); await clearAllCaches() }) } catch { /* reload anyway */ }
    window.location.assign(path)
  })
  box.append(msg, btn)
  document.body.appendChild(box)
}
